import { Component, Input, OnChanges } from '@angular/core';
import { ChartData, ChartOptions } from 'chart.js';
import { ChartComponent } from '../chart/chart.component';

// Thin preset over the shared ChartComponent for the small trend-preview line charts used next
// to a KPI number, throughout the design's Coverage/Analysis/Impact/Reach/Mentions screens.
// First real consumer is Coverage's KPI row (via KpiTileComponent); Overview has none.
@Component({
	selector: 'app-sparkline-chart',
	standalone: true,
	imports: [ChartComponent],
	templateUrl: './sparkline-chart.component.html',
	styleUrl: './sparkline-chart.component.scss',
})
export class SparklineChartComponent implements OnChanges {
	@Input({ required: true }) values!: number[];
	@Input() color = '#244896';
	@Input() height = '32px';
	// Coverage's signed-impact KPI sparkline shows a dashed grey line at y=0 (ported from the
	// design's Recharts <ReferenceLine>). Chart.js has no built-in reference line without an
	// extra plugin, so this is approximated with a second flat dataset at 0 - no new library.
	@Input() zeroLine = false;

	// Built once per actual input change (ngOnChanges), not as a getter re-read on every change
	// detection cycle - a getter here would hand ChartComponent a new object identity on every
	// read, making it destroy and recreate the Chart.js instance constantly.
	chartData: ChartData = { datasets: [] };

	readonly chartOptions: ChartOptions = {
		responsive: true,
		maintainAspectRatio: false,
		plugins: {
			legend: { display: false },
			tooltip: { enabled: false },
		},
		scales: {
			x: { display: false },
			y: { display: false },
		},
	};

	ngOnChanges(): void {
		this.chartData = {
			labels: this.values.map((_, i) => i),
			datasets: [
				...(this.zeroLine
					? [
							{
								data: this.values.map(() => 0),
								borderColor: '#d3d8e2',
								borderWidth: 1,
								borderDash: [2, 2],
								pointRadius: 0,
								tension: 0,
								fill: false,
							},
						]
					: []),
				{
					data: this.values,
					borderColor: this.color,
					borderWidth: 1.5,
					pointRadius: 0,
					tension: 0.4,
					fill: false,
				},
			],
		};
	}
}
